import React, { useEffect, useState } from 'react';
import { checkLoginInformation } from '../utils/user/checkLoginInformation';
import TagManager from 'react-gtm-module';
import { useLocation } from 'react-router-dom';

const LoginContext = React.createContext({});

const tagManagerArgs1 = {gtmId: 'GTM-PLTN2MW',};
const tagManagerArgs2 = {gtmId: 'GTM-KNFTXVGP',};
const tagManagerArgs3 = {gtmId: 'GTM-54WQX8V8',};

// Inicializar ambos GTM
TagManager.initialize(tagManagerArgs1);
TagManager.initialize(tagManagerArgs2);
TagManager.initialize(tagManagerArgs3);

const sendToDataLayer = (dataLayerArgs) => {
  TagManager.dataLayer({ ...dataLayerArgs, gtmId: 'GTM-PLTN2MW' });
  TagManager.dataLayer({ ...dataLayerArgs, gtmId: 'GTM-KNFTXVGP' });
  TagManager.dataLayer({ ...dataLayerArgs, gtmId: 'GTM-54WQX8V8' });
};


export function UserContextProvider({ children }) {
  const location = useLocation();
  const { pathname, search } = location;

  const [token, setToken] = useState('');
  const [loadingAuthentication, setLoadingAuthentication] = useState(true);
  const [userInfo, setUserInfo] = useState({
    email: '',
    first_name: '',
    last_name: '',
    empresa_colab: '',
  });
  const { first_name, last_name, empresa_colab } = userInfo;

  useEffect(() => {
    const params = new URLSearchParams(search);
    const userToken = params.get('tk');

    if (userToken !== null) {
      localStorage.setItem('jwt', userToken);
    }

    const tokenInStorage = localStorage.getItem('jwt');
 
    if (tokenInStorage) {
      setToken(tokenInStorage);
    }

    if (tokenInStorage !== null) {
      checkLoginInformation(tokenInStorage).then((data) => {
        console.log('hola: ', data);
        const { first_name, second_last_name, last_name, email, empresa_colab } = data.Data;
        setUserInfo({
          email: email,
          first_name: first_name,
          second_last_name: second_last_name,
          last_name: last_name,
          empresa_colab: empresa_colab,
        });
        localStorage.setItem('empresa_colab', empresa_colab);

        const dataLayerArgs = {
          gtmEventName: 'userData',
          dataLayer: {
            'companiapr': empresa_colab,
            'usuariopr': tokenInStorage,
            'emailpr' : btoa(email),
            'lastnameprd': last_name,
            'firstnameprd': `${first_name} ${second_last_name}`,
            'user_id': tokenInStorage,
          },
        };

        if (!first_name) {
          dataLayerArgs.dataLayer.user_id = 'out';
        }

        // Enviar dataLayer a ambos GTM
        sendToDataLayer(dataLayerArgs);

        setLoadingAuthentication(false);
      });

        // const urlWithoutToken = pathname;
        // window.history.replaceState({}, document.title, urlWithoutToken);
    } else {
      setLoadingAuthentication(false);
    }

    const urlWithoutToken = pathname;
    window.history.replaceState({}, document.title, urlWithoutToken);
  }, [pathname, search]);

  return (
    <LoginContext.Provider
      value={{ token, first_name, last_name, loadingAuthentication, empresa_colab }}
    >
      {children}
    </LoginContext.Provider>
  );
}

export const LoginContextConsumer = LoginContext.Consumer;
export default LoginContext;
